// extracted by mini-css-extract-plugin
export default {"auth-container":"Auth_auth-container__EZiOp","auth-loader-container":"Auth_auth-loader-container__lRYIK"};